import { BogieShimRequestModel } from '../../../shared/components/bogie-shim/bogie-shim-model';
import { AvailableActionViewModel, ReplacementCompartmentViewModel } from "../../action/action-models";
import { SystemModel, ComponentModel } from "../../interpretation/models/interpretation.model";
import { MeasurementToolsViewModel } from "../../manage-components/manage-components.model";
import { MeasurementPointRecord } from "../../rope-shovel/models/rope-shovel.model";

export class EquipmentDetails {
  public PercentWorn: number;
  public CustomerName: string;
  public JobsiteName: string;
  public SerialNumber: string;
  public UnitNumber: string;
  public LastInspectionDate: string;
  public NextInspectionDate: string;
  public Smu: number;
  public Doe: number;
  public Ltd: number;
  public PropelLtd: number;
  public Make: string;
  public MakeId: number;
  public Model: string;
  public Family: string;
  public EquipmentPhoto: string;
  public CustomerId: number;
  public JobsiteId: number;
  public NextSmu: number;
  public InspectEvery: number;
  public InspectEveryUnitTypeId: number;
  public EquipmentSetupDate: string;
  public Bcm: number;
  public Ton: number;
  public IsThermographyEnable: boolean;
  public Eval: string;
  public AdditionalUnitNo: string;
  public FamilyId: number;
  public propelPercentage: number;
  public propelHrs: number;
  public SumWornL: number;
  public SumWornR: number;
  public EvalL: string;
  public EvalR: string;
  public MonoblockCMUL: number;
  public MonoblockCMUR: number;
  public MonoblockResidualL: number;
  public MonoblockResidualR: number;
  public ModelId: number;
  public LastInspectionDate_: Date;
  public LastInspectionSMU: number;
  public EqStatus: string;
  public EqConditionStatusId: number;
  public LoggedUser: string;
  public ShowHideCRoller: boolean;
  public EnableDistTravelledTracking: boolean;
  public ShowPropelHrsPerc: boolean;
  public AllowToggleCRoller: boolean;
  public DOE: number;
  public DistanceForward: number;
  public DistanceReverse: number;
  public LastInspectionWorn: boolean;
  public BogieShimLeft: BogieShimRequestModel;
  public BogieShimRight: BogieShimRequestModel;
  public EnableBogieShim: boolean;
  public EnableManualInspection: boolean;
  public EnableFrameConfiguration: boolean;
  public EnableCannonType: boolean;
  public SummaryNotesExists: boolean;
  public EquipmentComments:string;
  public EnableEqualiserBar: boolean;
  public EqBudgetLife: number;
  public IsEqualiserBarExists: boolean;
  public IsCondition: boolean;
}

export class EquipmentActionHistory {
  public history_id: number;
  public action_name: string;
  public equnit_auto: number;
  public action_type_auto: number;
  public event_date: string;
  public cmu: number;
  public cost: number;
  public comment: string;
  public L_ChainCMU: number;
  public R_ChainCMU: number;
  public entry_user_auto: number;
  public entry_user_name: string;
  public equipment_smu: number;
  public equipment_PMU: number;
  public equipment_ltd: number;
  public entry_date: string;
  public LabourCost: number;
  public PartsCost: number;
  public MiscCost: number;
  public recordStatus: number;
  public side: number;
  public pos: number;
  public CompType: string;
  public totalCost: number;
  public currency: string;
  public ActionJobsite: string;
  public ActionJobsiteId: number;
  public ReplacedPos: number;
  public DOE: number;
  public DistanceForward: number;
  public DistanceReverse: number;
  public RunningCost: number;
  public IsLastAction: boolean;
  public AllowEditAction: boolean;
  public EnableDistTravelledTracking: boolean;
  public selected: boolean = true;
}

export class UpdateActionHistoryRequest {
  equipmentId: number;
  actionIds: string;
  actionDate: string;
  actionSMU: number;
  actionDateNew: string;
  actionSMUNew: number;
  distanceForward: number;
  distanceReverse: number;
  allSelected: boolean;
  actionPMU: number;
}

export class ActionType {
  public action_type_auto: number;
  public action_description: string;
}

export class SystemDetailVM {
  Data?: SystemDetails;
  Status?: number;
  Message?: string;
}

export class SystemDetails {
  public Id: number;
  public SerialNumber: string;
  public LifeLived: number;
  public LifeLivedKm: number;
  public TotalComponentPurchaseCost: number;
  public TotalComponentRepairsCost: number;
  public DateInstalled: string;
  public EquipmentSmuAtInstall: number;
  public EquipmentDOEAtInstall: number;
  public Side: string;
  public SystemType: string;
  public Components?: ComponentDetails[] = [];
  public ToeOutFrame: number;
  public CastFrame: number;
  public JobsiteId: number;
  public MakeId: number;
  public ActionSelectionId: number;
  public SysReplaceActionId: number;
  public NewSerialNo: string;
  public NewBudgetLife: number;
  public NewBudgetDistance: number;
  public NewFrameCost: number;
  public BudgetLife: number;
  public BudgetDistance: number;
  public FrameCost: number;
  public SystemCondition: string;
  public SystemConditionColor: string;
  public ShowTodayWorn: boolean;
  public RemoveStatusId: number = 1;
  public EnableFrameConfiguration: boolean;
  public EnableCannonType: boolean;
  public BogieShimLeft: BogieShimRequestModel;
  public BogieShimRight: BogieShimRequestModel;
  public ComponentPitch: number;
  public SmuAtCO: number;
  public DOEAtCO: number;
  public SMUDateCO: string;
  public DOEDateCO: string;
  public HistoricalHours: number;
  public HistoricalDistance: number;
}

export class ComponentDetails {
  public Id: number;
  public Photo: string;
  public PercentWorn: number;
  public ForeCastPercentWorn: number;
  public Name: string;
  public Brand: string;
  public MakeId: number;
  public Cmu: number;
  public ForeCastCmu: number;
  public RemainingLife100: number;
  public RemainingLife120: number;
  public InstallDate: string;
  public EquipmentSmuAtInstall: number;
  public PurchaseCost: number;
  public RepairsCost: number;
  public Position: number;
  public Side: string;
  public CompartTypeId: number;
  public CompartId: number;
  public BudgetLife: number;
  public BudgetDistance: number;
  public ProjectedLife100: number;
  public ProjectedLife120: number;
  public Difference: number;
  public EvalCode: string;
  public OEMPartNo: string;
  public MFRPartNo: string;
  public HasCleanerHoles: string;
  public isLatest: boolean;
  public PMU: number;
  public PropelRemainingLife100: number;
  public PropelRemainingLife120: number;
  public PropelProjectedLife100: number;
  public PropelProjectedLife120: number;
  public BushTurnedBudgetLife: number;
  public BushTurnedPercent: number;
  public IsBushTurned: boolean;
  public CalculatedWorn: number;
  public MLink: number;
  public JobNumber: string;
  public AssetNumber: string;
  //Action
  public ActionSelectionId: number;
  public AvailableActions: AvailableActionViewModel[];
  public SelectedActionTypeId: number;
  public ActionBrandId: number;
  public ActionWorn: number = null;
  public ActionCMU: number = null;
  public ActionCost?: number = null;
  public ActionDate?: number;
  public ActionSMU?: number;
  public ActionSide?: number;
  public ActionBudgetLife?: number;
  public ActionBudgetDistance?: number;
  public ActionComponentId?: number;
  public ActionsReplaceOption?: ReplacementCompartmentViewModel[];
  public isExpand: boolean;
  public ComponentId: number;
  public MPRecords: MeasurementPointRecord[];
  public ActionSucess: number = null;
  public allRollers: ComponentDetails[];
  public ChainSysReplaceAction: number;
  public ChainSysNewSrial: string = "";
  public SwapComponentId: number;
  public UOM: number;
  public ActionReading: number;
  public ActionToolId: number;
  public PossibleTools: MeasurementToolsViewModel[];
  public showCalcuator: boolean = false;
  public ActionComment: string;
  public ActionWO: string;
  public ActionWOId: number;
  public ToolId: number;
  public Reading: number;
  public showShoeDetails: boolean = false;
  public ShoeSize: number;
  public GrouserId: number;
  public CleanerHolesId: number;
  public DOC: number;
  public ResDOC100: number;
  public ResDOC120: number;
  public ActionDOC: number;
  public IsCompartHasChild: boolean;
  public PartCost: number = 0;
  public LaborCost: number = 0;
  public MiscCost: number = 0;
  public Comment: string;
  public HoursGained: number;
  public ComponentStatus: number;
  public QuoteDetailId: number;
  public isForDelete: boolean;
  public BushTurnRemainingHours: number;
  public BushTurnedCalc: number;
  public BushTurnResidualLife: number;
  public AfterBushTurnedHours: number;
  public CmuAtTurn: number;
  public ParentComponentId: number;
  public IsChild: number;
  public SystemId: number;
  public ActionPMU: number = null;
  public PropelBudget: number;
  public Condition?: string;
  public MeasurementCenter?: number;
  public MeasurementOuterLeft?: number;
  public MeasurementOuterRight?: number;
}

export class Inspection {
  public Id: number;
  public Eval: string;
  public Date: string;
  public Interpreted: boolean;
  public QuoteId: number;
  public IsReportSaved: number;
  public Smu: number;
  public hasTemperature: boolean;
  public IsThermography: boolean;
  public IsAction: boolean;
  public LeftComp: ComponentModel[] = [];
  public RightComp: ComponentModel[] = [];
  public InspDate: Date;
  public isDocAttached: boolean;
  public DocCount: number;
  public Distance: number;

}

export class InspectionHistroyWornInfo {
  public Id: number;
  public Date: string;
  public Smu: number;
  public Inspector: string;
  public EPMU: number;
  public PMUpercentage: number;
  public CrawlerBeltEPMU: number;
  public CrawlerBeltPMUpercentage: number;


  public LeftSide: SystemInspectionInfo[] = [];
  public RightSide: SystemInspectionInfo[] = [];

  public LeftThermoChain: SystemInspectionInfo[] = [];
  public RightThermoChain: SystemInspectionInfo[] = [];

  public LeftAdditional: SystemInspectionInfo[] = [];
  public RightAdditional: SystemInspectionInfo[] = [];
  public NoAdditional: SystemInspectionInfo[] = [];
  public ChainWorst_L: string;
  public ChainWorst_R: string;
  public L_expanded: boolean;
  public R_expanded: boolean;

  public generalComment: string;
  public Interpcomment: string;
  public RspNote: string;

  public SumWornL: number;
  public SumWornR: number;
  public MonoblockCMUL: number;
  public MonoblockCMUR: number;
  public MonoblockResidualL: number;
  public MonoblockResidualR: number;
  public InspectionType: string;
  public InspectionTypeId: number;
  public ActionComment: ActionHistoryInfo[];
  public Interpreted: boolean;
  public Jobsite: string;
  public DistanceKm: number = 0;
  public DistanceKmDifference: number = 0;
  public AvgDailyUsage: number = 0;
}

export class ActionHistoryInfo {
  public Comment: string;
}

export class SystemInspectionInfo {
  public Worn: number;
  public ComponentId: number;
  public Eval: string;
  public isThermo: boolean;
  public ThemEval: string;
  public CompartTypeId: number;
  public Position: number;
  public CompartTypeName: string;
  public ComponentName: string;
  public CalculatedWorn: number;
  public isExpand: boolean;
  public MPRecords: MeasurementPointRecord[];
  public SumCalculatedWorn: number;
  public CMU: number;
  public reading: number;
}

export class UpdateSMUReadingModel {
  public equipmentId: number;
  public currentReading: number;
  public currentDistanceReading: number;
  ForwardDistance: number;
  ReverseDistance: number;
  public dateReadSMU: string;
  public bcm: number;
  public ton: number;
  public IsEstimatedDistance: boolean;
}


export class InspectionHistory {
  public system: string
  public componentName: string;
  public Eval: string;
  public Wornpercentage: number;
}

export class ChangeMeterUnitModel {
  public equipmentId: number;
  public newSMUReadingOnNewMeter: number;
  public oldMeterSMUReading: number;
  public newPMUReadingOnNewMeter: number;
  public oldMeterPMUReading: number;
  public dateReplaced: Date;
}



export class UpdateInspectionForecastingInfoViewModel {
  public EquipmentId: number;
  public InspectEvery: number;
  public InspectEveryUnitType: number;
}
export class FamilyImagesChainFrameImgModel {
  public familyId: string
  public frameImage: string
  public chainImage: string
}

export class EquipmentSMUHistoryVM {
  public equipmentId: number
  public Date: string
  public equipmentSMU: number
  public equipmentBCM: number
  public equipmentTON: number
  public ActionType: string
}
export class ComponentWearGraph {
  public Date: Date;
  public WornPercentage: number;
  public CompartName: string;
  public SMU: number;
  public IsProjected: boolean;
  InspectionTypeId: number;
  SMUProjected: number;
}

export class InspectionListVM {
  public SMU: number;
  public Name: string;
  public IsProjected: boolean;
  InspectionTypeId: number;
  SMUProjected: number;
}

export class ComponentCMU {
  public CMU: number;
  public CompName: string;
  public IsProjected: boolean;
  InspectionTypeId: number;
  SMUProjected: number;
}

export class InspectionWornInfo {
  public Id: number;
  public Date: string;
  public Smu: number;
  public systemInfo: SystemModel[];


}

export class ComponentWornInfo {
  public Id: number;
  public worn: number;
}


export class EquipmentModal {

  public SerialNumber: string;
  public AdditionUnit: string;
  public UnitNumber: string;

}

export enum EquipmentEnum {

  SerialNumber = 1,
  AdditionUnit = 2,
  UnitNumber = 3,
}

export class PatchTuple {
  public Make_Auto: any;
  public Model_Auto: any;
}

export class UpdateForecastDates {
  EquipmentId: number;
  PmDate: string;
  SecondPmDate: string;
  FloatingDate1: string;
  FloatingDate2: string;
}

export class ComponentChangeViewModel {
  EqUnitId: number;
  NewComponentId: number;
  OldComponentId: number;
  CompartTypeId: number;
  UserId: number;
  ShoeSizeId: number;
  ShoeGrouserId: number;
  CleanerHolesId: number;
  MakeId: number;
  BudgetLife: number;
  MLink: number;
  JobNumber: string;
  BushTurnedPer: number;
  AssetNumber: string;
  BushTurnedHour: number;
  ScreenId: number;
}

	export class EquipmentStatusViewModel{
		Id: number;
    EqStatusName: string;
    EqStatusNameEnum: string;
    SortOrder: number;
    IsActive: boolean;
    ColorCode: string;
	}
export class CompartDto {
  public Part_No: string;
  public Brand: string;
  public CompartId: number;
}

export interface CompartDtoVM {
  Data: CompartDto[];
  Status: number;
  Message: string;
}

export class ComponentPosition {
  public Pos: number;
  public Side: number;
}

export interface ComponentPositionVM {
  Data: ComponentPosition[];
  Status: number;
  Message: string;
}

export class ChildComponent {
  public CompartId: string;
  public CompartCode: string;
  public CompartName: string;
  public IsChild: boolean;
  public UserSelectable?: boolean;
}

export interface ChildComponentVM {
  Data: ChildComponent[];
  Status: number;
  Message: string;
}


export interface AddComponentRequest {
  EquipmentId: number;
  CompartId: number;
  CompartTypeId: number;
  BrandId: number;
  IsChild: boolean;
  ParentPosition: number;
  ToeOut: number;      // 1 = Toe Out, 2 = Straight
  BudgetLife?: number;
  CMU?: number;
  Cost?: number;
  Condition?: string;
}

export interface ApiResponse {
  Status: number;
  Message: string;
}

export class EquipmentCompartDto {
  public CompartId: string;
  public CompartCode: string;
  public CompartName: string;
}

export interface EquipmentCompartDtoVM {
  Data: EquipmentCompartDto[];
  Status: number;
  Message: string;
}

export class BushTurnedCalcParams {
  PercentWorn!: number;
  BudgetLife!: number;
  BushTurnedPercent!: number;
  CMU!: number;
}
export class EquipmentCompartmentTypeModel {
  public CompartTypeId: number;
  public CompartTypeName: string;
  public IsSelected: boolean;
  public PercentWornCalMethod: string;
public IsShovel: boolean;

}

export interface EquipmentPercentWornPreferenceDto {
  equipmentId: number;
  isWorstSelected: boolean;
  isAverageSelected: boolean;
  compartTypeIdList: number[];
  componentTypeIds: string;
}

export interface SMUValidationCheckRequest {
  equipmentId: number;
  actionDate: string;
  getAuto: number;
  actionSMU: number;
}

export interface AddNewCompValidation {
  EquipmentSerialNo: string;
  EquipmentUnitNo: string;
}

export interface AddNewCompValidationResponseVM {
  Data: AddNewCompValidationViewModel[];
  Status: number;
  Message: string;
}

export interface AddNewCompValidationViewModel {
  PrevSystemEquipmentId: number;
  InspectionId: number;
  EquipmentUnitNo: string;
  EquipmentSerialNo: string;
  SystemId: number;
  Side: number;
  CurrentSystemEquipmentId: number;
  SystemSerialNo: string;
  InspectionDate: Date;
}

export interface AddComValidationRequest {
  EquipmentId: number;
  SystemTypeId: number;
}

export interface EquipmentComponentWearModel {
  CompartTypeId: number;
 
  CompartType: string;
  BudgetLife: number;
  Data: ComponentWearDataModel[];
}

export interface ComponentWearDataModel {
  Compart: string;
  ComponentBudgetLife:number;
  Side: string;
  SMU: number;
  SMUAtInstall: number;
  HoursOnSurface: number;
  InspectionDate: Date;
  WornPercentage: number;
}

export interface InspectionHistoryTabularVM {
  InspectionAuto: number;
  EquipmentId_Auto: number;
  crsf_auto: number;
  Jobsite: string;
  UnitNo: string;
  InspectionDate: Date | string;
  DaysSince: number;
  SMUAtInspection: number;
  DiffFromPrevSMU: number;
  FWDDistance: number;
  ReverseDistance: number;
  TotalDistance: number;
  DiffFromLastDist: number;

  // NEW
  FwdDistanceChangePercentage: number;
  FwdDistanceChangePercentageSinceComponentInstall: number;

  FrameSerialLeft: string;
  FrameSerialRight: string;

  HrsOnFrameLeft: number;
  HrsOnFrameRight: number;

  // NEW
  DistanceOnFrameLeft: number;
  DistanceOnFrameRight: number;

  TrackTensionLeft: string;
  TrackTensionRight: string;
  IceLugHeightLeft: string;
  IceLugHeightRight: string;
  GrouserbarLeft: string;
  GrouserbarRight: string;
  InspectedBy: string;
  InspectType: string;
}

export interface InspectionHistoryComponentVM {
  InspectionAuto: number;
  ModuleUcsubAuto: number;
  ComponentId: number;
  ComponentTypeId: number;
  ComponentName: string;
  Side: string;
  PositionNo: number;
  WornPercentage: string;
  CMU: number;
  LastAction: string;
  EvalColor: string;
}

export interface InspectionHistoryComponentMetadataVM {
  ComponentTypeId: number;
  ComponentName: string;
  Side: string;
  PositionNo: number;
  DisplayName: string;
  SortOrder: number;
  DataColumn: string;
}

export interface InspectionHistoryTabularResponseVM {
  InspectionHistory: InspectionHistoryTabularVM[];
  Components: InspectionHistoryComponentVM[];
  ComponentMetadata: InspectionHistoryComponentMetadataVM[];
}

export interface InspectionComponentGroupVM {
  ComponentTypeId: number;
  ComponentName: string;
  Components: InspectionHistoryComponentMetadataVM[];
}


export interface ChartLegendPreference {
    Id: number;
    User_Auto: number;
    Compart_type_auto: number;
    Component: string;
    GraphType: string;
    IsVisible: boolean;
}

export interface EquipmentCompartTypePreferenceRequest {
  EquipmentId_Auto: number;
  CompartTypeId: number;
  IsSelected: boolean;
}
